import React, { Component } from 'react'
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import AddEditRoom from "../../views/rooms/AddEditRoom";
import Alert from 'react-s-alert';
import { currentPage, itemPerPage } from "../../constants/index";
import NDF from '../noDataFound'
import Pagination from '@material-ui/lab/Pagination';
import Grid from '@material-ui/core/Grid';
import { Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";


//Actions
import { getAllRooms, getRoomsByCommunityId, delRoom, delRoomByCommunity } from '../../actions/roomAction.js';
import { SetHeaderButtons } from '../../actions/headerButtonsActions';

//Engage Components
import { SweetConfirmationAlert } from '../../components/Alert/sweetAlert';


class Room extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            tableData: [
            ],
            isLoading: false,
            currentPage: currentPage,
            itemPerPage: itemPerPage,

            //Community
            superUserCommunitySelected: undefined,
            superUserRoomsLoaddedForCommunity: undefined,
            openCommunityCombo: false,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        if (localStorage.getItem('superAdmin') === "false") {

            this.getRooms();
        }

        this.SetHeaderButtons();
    }


    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    SetHeaderButtons = (open = false) => {
        const headerButtons = this.getHeaderButtons(open);
        this.props.SetHeaderButtons(headerButtons)
    }

    getHeaderButtons = (open = false) => {
        const communityIdExist = !!(localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0);

        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
        }

        return (
            <Grid container className='setupInfoSection' style={styles.globalActions}>
                {
                    !open ?
                        <Grid item container justify='flex-end' alignItems='center' style={styles.globalActions}>
                            {/* {
                              (isSuperAdmin && isSuperAdmin === true)?
                              <Grid item  xs={4} style={{backgroundColor:'#009EDD' ,border:'1px solid #009EDD', borderRadius:'25px',paddingLeft:'15px', marginRight:'15px', height:'39px'}} justify='center'>
                                  <SimpleSelect
                                      label={'Community'}
                                      onChangeHandler = {
                                          (evet, newItem) => 
                                          {
                                              if(newItem !== null && newItem !== ''){ 
                                                  localStorage.setItem('communityId',newItem.communityId);
                                                  this.setState({superUserCommunitySelected: newItem});
                                              } else{
                                                  this.setState({ superUserCommunitySelected:undefined} );
                                                  localStorage.removeItem('communityId');
                                                 
                                              }
                                          }
                                      }
                                      optionsItemsIconsData = {this.props.communityData? this.props.communityData : []}
                                      selected = {this.state.superUserCommunitySelected? this.state.superUserCommunitySelected :{}}
                                      disabled= {false}
                                  />
                              </Grid>
                              :
                              undefined 
  
                          } */}
                      <Grid
                        id='rooms_btn_add' 
                          item  xs={6} sm={5} md={3} lg={3}
                          disabled={!communityIdExist}
                          onClick={this.addRoom}  
                          className={!communityIdExist?"appbtn-engage disabledSkybluebtn-engage appbtn-list-engage appbtnBarButton":"appbtn-engage skybluebtn-engage appbtn-list-engage appbtnBarButton"}
                          >
                          New Room
                      </Grid> 
                  </Grid>
                  : 
                  <div className="appbtn-list-engage" style={styles.globalActions}>
                      <div id='rooms_btn_save' className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={this.SaveRoom}>
                          Save
                      </div> 
                      {/* <div className="appbtn-engage redbtn-engage" onClick={this.CancelRoom}>
                          Cancel
                      </div>                                                         */}
                        </div>

                }
            </Grid>
        )
    }


    getRooms = () => {
        this.props.getRoomsByCommunityId(localStorage.getItem('communityId'), true);
    }

    resize() {

        this.setState({ isMobile: window.innerWidth <= 970 });
    }




    handleDeleteClick = async (e, data, index) => {

        const title = 'Are you sure you want to delete the Room?';

        const { isConfirmed } = await SweetConfirmationAlert(title, 'alert_deleteRoom');

        if (isConfirmed) {
            this.deleteRoom({}, data);
        }
    }

    deleteRoom = (event, item, isActive) => {

        if (item._id) {

            this.props.delRoomByCommunity(item._id);
        }

        const lastPage = Math.ceil((this.props.tableData.length - 1) / this.state.itemPerPage);


        if (this.state.currentPage > lastPage) {
            this.handlePageChange(lastPage);

        }

        Alert.closeAll();
    }

    addRoom = () => {
        this.setState({ open: true, room: '' });
        this.SetHeaderButtons(true);


        if (this.props?.handlerOpenElementDetails) {
            this.props.handlerOpenElementDetails();
        }
        this.props.openAddRoom();
    };

    CancelRoom = () => {
        var link = document.getElementById('cancel_btn_rooms')
        link.click();

        this.props.closeAddRoom();

    }

    SaveRoom = () => {
        var link = document.getElementById('save_btn_rooms')
        link.click();
        this.props.closeAddRoom();

    }

    editRoom = (e, item, index) => {


        if (this.props?.handlerOpenElementDetails) {
            this.props.handlerOpenElementDetails();
        }

        this.setState({ room: item, open: true });
        this.SetHeaderButtons(true);
        this.props.openAddRoom();
    }

    handleClose = (pageNextRoom = 0) => {

        this.setState({ open: false });
        this.SetHeaderButtons(false);

        if (pageNextRoom > 0) {
            this.handlePageChange(pageNextRoom);
        }

        if (localStorage.getItem('communityId')) {
            setTimeout(() => { this.getRooms(); }, 200);
        }


        if (this.props.handlerCloseElementDetails) {
            this.props.handlerCloseElementDetails()
        }

        this.props.closeAddRoom();
    };

    handlePageChange = (number) => {

        if (number && typeof (number) == 'number' && number > 0) {
            this.setState({
                currentPage: Number(number)
            });
        }

    };

    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.communityData) {

            communityObj = this.props.communityData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };

    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    }
    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    }

    //#region  Inner Components
    RoomList = () => {
        const currentPage = this.state.currentPage;
        const itemPerPage = this.state.itemPerPage;
        const displayHeaders = this.state.isMobile ? 'none' : 'flex';
        const totalRooms = this.props.tableData && this.props.tableData.length;
        const indexOfLastTodo = currentPage * itemPerPage;
        const indexOfFirstTodo = indexOfLastTodo - itemPerPage;
        const currentData = this.props.tableData && this.props.tableData.length ? this.props.tableData.slice(indexOfFirstTodo, indexOfLastTodo) : [];

        //styles
        const styles = {
            title: {
                flexGrow: 1
            },
            globalActions: {
                alignContent: 'right',
                marginLeft: 'auto',
                marginRight: '0px',
                textAlign: 'right'
            },
            disabledButton: {
                backgroundColor: 'white'
            },
            DeleteButton: {
                backgroundColor: '#DB5B70'
            }
        }

        return (
            <Grid container >
                <Grid container style={{ flexGrow: 1, display: displayHeaders }} >
                    <Grid item xs={8} className='defaultTextStyles'>Room</Grid>
                    <Grid item xs={2} className='defaultTextStyles'>Edit</Grid>
                    <Grid item xs={2} className='defaultTextStyles'>Remove</Grid>
                </Grid>
                <Grid container>
                    {currentData && currentData.map((item, index) => {
                        return (
                            <Grid container id={`rooms_row_${item._id}`} key={index} className='rowEngageStyleList cursorDefault' alignContent='center' style={{ backgroundColor: '#1f1f1f', padding: '5px', marginTop: '6px' }}>
                                <Grid item xs={12} sm={12} md={8} style={{ textAlign: 'center' }} id={`rooms_row_${item._id}_name`}>{item.name}</Grid>
                                <Grid item xs={12} sm={12} md={2}  >
                                    <Button
                                        id={`rooms_edit_btn_${item._id}`}
                                        variant="contained"
                                        value={item._id}
                                        color='secondary'

                                        onClick={(e) => {
                                            this.editRoom(e, item);
                                        }}>
                                        <EditIcon />
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={12} md={2}>
                                    <Button
                                        id={`rooms_delete_btn_${item._id}`}
                                        variant="contained"
                                        value={item._id}
                                        color='secondary'
                                        style={styles.DeleteButton}
                                        onClick={(e) => {
                                            this.handleDeleteClick(e, item);
                                        }}>
                                        <DeleteIcon />
                                    </Button>
                                </Grid>
                            </Grid>
                        )
                    }
                    )}

                    {/* pagination */}
                    <div style={{ marginLeft: 'auto', marginRight: '0' }} >
                        <Grid item xs={12} >
                            {
                                currentData && currentData.length ?
                                    <Pagination
                                        count={Math.ceil(totalRooms / itemPerPage)}
                                        defaultPage={1}
                                        onChange={(e, item) => { this.handlePageChange(item) }}
                                        page={currentPage}
                                        showFirstButton
                                        showLastButton
                                        siblingCount={1}
                                        boundaryCount={1}
                                    />
                                    :
                                    <NDF />
                            }
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        )
    };
    //#endregion

    setIdsPaginationHandler = () => {
        try {
            const pagContainer = document.getElementsByClassName('MuiPagination-ul');
            if (pagContainer && pagContainer.length > 0 && pagContainer[0]) {
                const pag = pagContainer[0];
                const liElements = pag.getElementsByTagName('li');
                if (liElements && liElements.length >= 4) {
                    for (let i = 0; i < liElements.length; i++) {
                        liElements[i].removeAttribute('id')
                    }
                    const btn_GoToFist = liElements[0];
                    if (btn_GoToFist) {
                        btn_GoToFist.setAttribute('id', 'pag_btn_gotofirst');
                        btn_GoToFist.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_back = liElements[1];
                    if (btn_back) {
                        btn_back.setAttribute('id', 'pag_btn_goback');
                        btn_back.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_forward = liElements[liElements.length - 2];
                    if (btn_forward) {
                        btn_forward.setAttribute('id', 'pag_btn_goforward');
                        btn_forward.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_GoToLast = liElements[liElements.length - 1];
                    if (btn_GoToLast) {
                        btn_GoToLast.setAttribute('id', 'pag_btn_gotolast');
                        btn_GoToLast.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }

                    for (let i = 2; i < liElements.length - 2; i++) {
                        const btn = liElements[i].getElementsByTagName('button');

                        if (btn && btn.length > 0 && btn[0] && btn[0].textContent.length > 0) {
                            liElements[i].setAttribute('id', `pagElement_${btn[0].textContent}`);
                        }
                    }
                }
            }
        } catch (err) { }
    }


    render() {
        //Set IDS PAGINATION
        setTimeout(() => {
            this.setIdsPaginationHandler();
        }, 100);


        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        if (isSuperAdmin && localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0 && this.state.superUserCommunitySelected === undefined) {
            this.setState({ superUserCommunitySelected: this.GetCommunityObjectForSupuerUserCombo(localStorage.getItem('communityId')) });
        }

        if (
            (
                this.state.superUserCommunitySelected &&
                (
                    !this.state.superUserRoomsLoaddedForCommunity ||
                    (this.state.superUserRoomsLoaddedForCommunity !== this.state.superUserCommunitySelected)
                )
            ) ||
            (
                this.state.superUserCommunitySelected === undefined &&
                this.state.superUserRoomsLoaddedForCommunity !== undefined
            )
        ) {
            this.getRooms();
            this.setState({ superUserRoomsLoaddedForCommunity: this.state.superUserCommunitySelected });
            this.setState({ currentPage: 1 });
        }

        const currentPage = this.state.currentPage;
        const itemPerPage = this.state.itemPerPage;

        const totalRooms = this.props.tableData && this.props.tableData.length;
        const lastPage = Math.ceil(totalRooms / itemPerPage);
        const pageNextRoom = totalRooms % itemPerPage === 0 ? lastPage + 1 : lastPage;


        return (
            <Grid container >
                <main className="content-engage" >
                    <Grid item container className='PageTitle' justify='center' alignContent='center'>
                        {
                            this.state.open ?
                                undefined
                                :
                                <Grid item id='rooms_title'>
                                    Rooms ({totalRooms})
                                </Grid>
                        }
                    </Grid>
                    <Grid item container>
                    {
                        this.state.open ? 
                        <AddEditRoom closeDialog={this.handleClose} data={this.state.room} newItemPage = {pageNextRoom} currentPage= {currentPage} 
                            characterLimit={this.props.characterLimit}
                            openTranslation={this.props.addTranslations}   
                            closeTranslations={this.props.closeTranslations} 
                        /> 
                        :
                        <this.RoomList/>                        
                    }
                    </Grid>
                </main>
            </Grid>
        )
    }
}

function mapStateToProps(state, dispatch) {
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId })) : [];

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        tableData: state.roomReducer && state.roomReducer.roomData,
        communityData: communityData

    }
}

Room = reduxForm({
    form: 'DeviceForm',
    // validate,
    enableReinitialize: true,
})(Room);

export default connect(mapStateToProps, { getAllRooms, getRoomsByCommunityId, delRoom, delRoomByCommunity, SetHeaderButtons })(Room);
